import { simple } from 'src/utils/reducers';

import * as query from './reducers/query';
import * as assign from './reducers/assign';
import * as unassign from './reducers/unassign';
import * as update from './reducers/update';

// eslint-disable-next-line import/no-default-export
export default simple({
    TRANSACTIONS_QUERY_REQUEST: query.request,
    TRANSACTIONS_QUERY_ERROR: query.error,
    TRANSACTIONS_QUERY_FINISH: query.finish,

    TRANSACTIONS_ASSIGN_REQUEST: assign.request,
    TRANSACTIONS_ASSIGN_ERROR: assign.error,
    TRANSACTIONS_ASSIGN_FINISH: assign.finish,

    TRANSACTIONS_UNASSIGN_REQUEST: unassign.request,
    TRANSACTIONS_UNASSIGN_ERROR: unassign.error,
    TRANSACTIONS_UNASSIGN_FINISH: unassign.finish,

    TRANSACTIONS_UPDATE_REQUEST: update.request,
    TRANSACTIONS_UPDATE_ERROR: update.error,
    TRANSACTIONS_UPDATE_FINISH: update.finish,
});
